import { Form, Input, Select, Col } from 'antd';
import PropTypes from 'prop-types';

const EstatusFormulario = ({ reasonCancel, setReasonCancel }) => {
  const handleReasonCancel = (e) => {
    if (e === 3) {
      setReasonCancel(true);
    } else {
      setReasonCancel(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      <Col span={8}>
        <Form.Item
          label="Estatus:"
          required
          name="estatus"
          rules={[{ required: true, message: 'El campo es requerido' }]}
          style={{ width: '20em', margin: '1em 0' }}>
          <Select
            onChange={handleReasonCancel}
            options={[
              { value: 2, label: 'No validado' },
              { value: 3, label: 'Cancelado' },
              { value: 4, label: 'Validado' }
            ]}
            placeholder="Selecciona..."
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        {reasonCancel ? (
          <Form.Item
            style={{ width: '20em', margin: '1em 0', marginLeft: '7em' }}
            name="motivoCancelacion"
            label="Motivo de cancelación"
            rules={[
              {
                required: true,
                message: 'Por favor ingresa el motivo de cancelación.'
              }
            ]}>
            <Input placeholder="Escribe el motivo" maxLength={100} />
          </Form.Item>
        ) : null}
      </Col>
    </div>
  );
};

EstatusFormulario.propTypes = {
  form: PropTypes.shape({
    getFieldValue: PropTypes.func,
    resetFieldsValue: PropTypes.func
  }).isRequired,
  reasonCancel: PropTypes.bool.isRequired,
  setReasonCancel: PropTypes.func.isRequired
};

export default EstatusFormulario;
